// src/experiments/apiHeader.js
//
// Optional `X-Experiments` request header, so the API can log which arm a
// lead came from and the business can compare lead quality per variant, not
// only form submissions. It ships OFF: the API is cross-origin, and a header
// that is not on its CORS allowlist fails every request at preflight. Flip
// SEND_EXPERIMENTS_HEADER in experiments.config.js only after the API team
// has confirmed the allowlist and the logging.

import { SEND_EXPERIMENTS_HEADER } from './experiments.config';
import { getExperimentsString } from './exposure';

export const EXPERIMENTS_HEADER = 'X-Experiments';

export function withExperimentsHeader(
  fetchOptions,
  enabled = SEND_EXPERIMENTS_HEADER
) {
  if (!enabled) return fetchOptions;
  try {
    const experiments = getExperimentsString();
    if (!experiments) return fetchOptions;

    const headers = fetchOptions?.headers;
    if (typeof Headers !== 'undefined' && headers instanceof Headers) {
      const next = new Headers(headers);
      next.set(EXPERIMENTS_HEADER, experiments);
      return { ...fetchOptions, headers: next };
    }
    return {
      ...fetchOptions,
      headers: { ...(headers || {}), [EXPERIMENTS_HEADER]: experiments },
    };
  } catch {
    return fetchOptions;
  }
}
